/**
 * Query params for a subscribe link on a page template. redirect_to is
 * forwarded exactly as it arrived on the landing page URL; /subscribe/one is
 * what decides where the subscriber lands once checkout finishes.
 */
const subscribeParams = ({
  offerCode,
  redirectTo,
}: {
  offerCode?: string | null;
  redirectTo?: string | null;
}) => ({
  ...(offerCode ? { offer: offerCode } : {}),
  ...(redirectTo ? { redirect_to: redirectTo } : {}),
});

export default subscribeParams;
